export function formatRateLimitMessage(
  retryAfterSeconds: string | null
): string {
  if (!retryAfterSeconds) {
    return "You've made too many requests. Please wait a moment and try again.";
  }
  const minutes = Math.ceil(Number(retryAfterSeconds) / 60);
  return `You've made too many requests. Please retry after ${minutes} minute${minutes === 1 ? "" : "s"}.`;
}
